import { SceneObject } from '@ikea-aoa/component-view-3d';
import { SelectionVisuals } from './SelectionUi/SelectionVisuals';
import { OverlayAnimation } from './SelectionUi/OverlayAnimation';

export class SelectionUi {
	private selected: Array<SceneObject> | null;
	private unselected: Array<SceneObject> | null;
	private uiVisuals: SelectionVisuals;

	constructor(private sceneItems: Map<string, SceneObject>) {}

	public setSelection(id: string, forceUpdate?: boolean): void;
	public setSelection(objects: Map<string, SceneObject>, forceUpdate?: boolean): void;

	public setSelection(selection: string | Map<string, SceneObject>): void {
		let selectedObjects: Array<SceneObject> = new Array<SceneObject>();
		let unselectedObjects: Array<SceneObject> = new Array<SceneObject>();

		if (typeof selection == 'string') {
			const sceneItem = this.sceneItems.get(selection);
			if (sceneItem) {
				selectedObjects = [sceneItem];

				const unselected = new Map(this.sceneItems);
				unselected.delete(selection);
				unselected.forEach((unselect) => {
					if (
						unselect.articleId.includes(sceneItem.articleId) &&
						unselect.articleId.includes('_backrest') &&
						unselect.parentId === selection
					) {
						unselected.delete(unselect.id);
					}
				});
				unselectedObjects = Array.from(unselected.values());
			} else {
				throw 'SelectionUi: setSelection(): sceneItem does not exist';
			}
		} else {
			selectedObjects = Array.from(selection.values());
			unselectedObjects = new Array<SceneObject>();

			this.sceneItems.forEach((item) => {
				if (!selection.has(item.id)) {
					unselectedObjects.push(item);
				}
			});
		}

		this.selected = selectedObjects;
		this.unselected = unselectedObjects;

		this.showSelectionUi();
	}

	public clearSelection(): void {
		this.hideSelectionUi();
		this.selected = null;
		this.unselected = null;
	}

	private getUiVisuals(): SelectionVisuals {
		if (!this.uiVisuals) {
			this.uiVisuals = new OverlayAnimation();
		}
		return this.uiVisuals;
	}

	private hideSelectionUi(): void {
		const visuals = this.getUiVisuals() as OverlayAnimation;
		visuals.animateDeselection();
	}

	private showSelectionUi(): void {
		const visuals = this.getUiVisuals() as OverlayAnimation;
		if (this.selected && this.unselected) {
			visuals.props.selected = this.selected;
			visuals.props.unselected = this.unselected;
			visuals.animateSelection();
		}
	}
}
